var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSource(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 54,
    height: 54,
    viewBox: "0 0 44 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M0 16C0 7.163 7.162 0 16 0c8.837 0 16 7.162 16 16 0 8.837-7.162 16-16 16-8.837 0-16-7.162-16-16z"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "b",
    width: "168.8%",
    height: "168.8%",
    x: "-34.4%",
    y: "-21.9%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 4,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.161514946 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(6 2)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D8D8D8",
    stroke: "#252525",
    d: "M15.5 22.5h1v16h-1z"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "c",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#b)",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    x: 1,
    y: 1,
    fill: "#388BF2",
    stroke: "#FFF",
    strokeWidth: 2,
    mask: "url(#c)",
    rx: 15
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M13.672 16.154a1.849 1.849 0 0 1 1.018-.303h3.468c1.017 0 1.842.82 1.842 1.823V23h-7.152v-5.161c-1.503-.305-2.571-1.175-3.214-2.43-.473-.92-.63-1.822-.634-2.465a.894.894 0 0 1 1.788-.01c0 .081.014.258.056.495.07.401.194.8.38 1.165.462.9 1.22 1.457 2.448 1.56zm2.628-1.792a2.681 2.681 0 1 1-.001-5.363 2.681 2.681 0 0 1 .001 5.363z",
    mask: "url(#c)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 40,
    r: 2,
    fill: "#252525"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSource);
export default __webpack_public_path__ + "static/media/source.6cbdae654c7161f0db5abe73bd3c4e52.svg";
export { ForwardRef as ReactComponent };